import {AccordionComponent} from "./accordion.component";

export const Accordion = AccordionComponent;
